import ContractorSelectorInput from "../../../components/controls/inputs/ContractorSelectorInput";
import GoodsSelectorInput from "../../../components/controls/inputs/GoodsSelectorInput";
import ScalingRatioSelectorInput from "../../../components/controls/inputs/ScalingRatioSelectorInput";
import BaseDocumentCreator from "../../../components/documents/baseDocumentCreator";
import { IInventoryVedItemEditDTO, IInventoryVedItemViewDTO } from "../../../libs/coreapi-dto/documents/invoice/inventory/inventoryVedItem";
import { CreateVariant } from "../../MasterTabsProvider";
import { InventoryVedItemFormDataType } from "./inventoryVedItemFormTab";
import { IButton } from "../../../components/modalWindows/BaseModalWindow";
import { ICostInfoDTO, IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { NumberInput, TextInput } from "../../../components/controls/inputs";
import GridWrapper from "../../../components/controls/GridWrapper";
import TaxTypeSelectorInput from "../../../components/controls/inputs/TaxTypeSelectorInput";
import { FC, useEffect, useRef, useState } from "react";
import Link from "../../../components/controls/link";
import FlexRow from "../../../components/controls/FlexRow";
import styles from "./styles/index.module.scss";
import { useTabsContext } from "../../../system/providers/tabsProvider";
import { ContractorDataProvider } from "../../../Services/DataProviders/ContractorDataProvider";
import { useAppContext } from "../../../system/providers/appContextProvider";
import { TaxTypeDataProvider } from "../../../Services/DataProviders/TaxTypeDataProvider";
import { GoodsDataProvider } from "../../../Services/DataProviders/GoodsDataProvider";
import { Accordion } from "../../../components/controls/accordion";
import { ScalingRatioDataProvider } from "../../../Services/DataProviders/ScalingRatioDataProvider";
import { DecimalInputV2, MoneyFormatComponent } from "../../../components/controls/inputs/BaseInput";
import { NIL as uuidNull } from "uuid";
import { useTranslation } from "react-i18next";
import { IGoodsDTO } from "../../../libs/coreapi-dto/dirs/goods";
import { ITaxTypeDTO } from "../../../libs/coreapi-dto/dirs/taxType";
import { useForm } from "../../../system/hooks/useForm";
import { roundMoneyFormat } from "../../../system/functions/round";
import { ISerialDTO } from "../../../libs/coreapi-dto/dirs/serial";
import { SeriesModalWindow } from "../../Dictionaries/Series/SeriesAndCertificateModal/SeriesModalWindow";
import classNames from "classnames";
import GridSelectorInput from "../../../components/controls/GridSelectorInput";
import RegisterPriceSelectorModal from "../../Dictionaries/RegisterPrice/RegisterPriceSelectorModal";

interface IInventoryVedItemFormProps {
    idGlobal: string;
    variant: CreateVariant;
    data: InventoryVedItemFormDataType;
    onSubmit?: (editItem: IInventoryVedItemEditDTO, viewItem: IInventoryVedItemViewDTO) => void;
}

const defaultCostInfo: ICostInfoDTO = { vat: 0, price: 0, vatPrice: 0, priceIncVat: 0, sum: 0, vatSum: 0, sumIncVat: 0, adprice: 0 };

interface IValidator {
    producerPrice: number;
    registerPrice: number;
    supplierPriceWithVat: number;
    retailPriceWithVat: number;
    supplier: IEntitySimpleDTO;
    goods: IEntitySimpleDTO;
    scalingRatio: IEntitySimpleDTO;
}

const InventoryVedItemForm: FC<IInventoryVedItemFormProps> = (props) => {
    const appContext = useAppContext();
    const tabContext = useTabsContext();

    const contractorDP = new ContractorDataProvider(appContext.coreApiService);
    const taxTypeDP = new TaxTypeDataProvider(appContext.coreApiService);
    const goodsDP = new GoodsDataProvider(appContext.coreApiService);
    const scalingRatioDP = new ScalingRatioDataProvider(appContext.coreApiService);

    const [disabled, setDisabled] = useState<boolean>(false);
    const [isGnvls, setIsGnvls] = useState<boolean>(false);
    const [entity, setEntity] = useState<IInventoryVedItemEditDTO>({
        idGlobal: props.idGlobal
    } as IInventoryVedItemEditDTO);

    const [lot, setLot] = useState<IEntitySimpleDTO | null>(null);
    const [supplier, setSupplier] = useState<IEntitySimpleDTO | null>(null);
    const [goods, setGoods] = useState<IEntitySimpleDTO | null>(null);
    const [scalingRatio, setScalingRatio] = useState<IEntitySimpleDTO | null>(null);
    const [supplierTaxType, setSupplierTaxType] = useState<IEntitySimpleDTO | null>(null);
    const [retailTaxType, setRetailTaxType] = useState<IEntitySimpleDTO | null>(null);
    const [supplierCostInfo, setSupplierCostInfo] = useState<ICostInfoDTO>(defaultCostInfo);
    const [retailCostInfo, setRetailCostInfo] = useState<ICostInfoDTO>(defaultCostInfo);

    const [isOpenSeriesModal, setIsOpenSeriesModal] = useState<boolean>(false);
    const [itemSeries, setItemSeries] = useState<ISerialDTO>({} as ISerialDTO);

    // Только для режима формирования строки из номенклатуры
    const [producerPrice, setProducerPrice] = useState<number>(0.00);

    const { t } = useTranslation();
    const baseT = (value: string) => t("documents.invoice." + value);
    const errorsT = (value: string) => t("errors." + value);

    const kizQuantity = useRef(0);
    const validateReestr = { isGnvls, documentDate: props.data.documentDate };

    const isValidProducerPrice = () => {
        if ((props.data.type === "goods" || (props.data.type === "entity" && !props.data.byLot)) &&
            (producerPrice === undefined || producerPrice <= 0) && isGnvls)
            return { bool: false, message: "required" };

        if (producerPrice > entity.registerPrice) return { bool: false, message: "exceededProducerPrice" };
        return { bool: true, message: "" };
    }

    const { isValid, errors, setErrors } = useForm<IValidator>({
        validations: {
            producerPrice: {
                custom: {
                    isValid: () => {
                        return isValidProducerPrice().bool;
                    },
                    message: errorsT(isValidProducerPrice().message),
                },
            },
            registerPrice: {
                required: {
                    value: isGnvls && (entity.registerPrice === undefined || entity.registerPrice <= 0) ? true : false,
                    message: errorsT("required"),
                },
            },
            supplierPriceWithVat: {
                required: {
                    value: supplierCostInfo.priceIncVat > 0 ? false : true,
                    message: errorsT("required"),
                },
            },
            retailPriceWithVat: {
                required: {
                    value: retailCostInfo.priceIncVat > 0 ? false : true,
                    message: errorsT("required"),
                },
            },
            supplier: {
                required: {
                    value: supplier === null || supplier === undefined,
                    message: errorsT("required")
                }
            },
            goods: {
                required: {
                    value: goods === null || goods === undefined,
                    message: errorsT("required")
                }
            },
            scalingRatio: {
                required: {
                    value: scalingRatio === null || scalingRatio === undefined,
                    message: errorsT("required")
                }
            }
        },
    });

    useEffect(() => {
        switch (props.data.type) {
            case "lot":
                const lot = props.data.lot;

                let entityObj = {
                    ...entity,
                    hasLot: true,
                    quantity: lot.quantityRem,
                    quantityRem: lot.quantityRem,
                    isKiz: lot.isKiz ?? false,
                    isKizBox: lot.isKizBox ?? false,
                    idLotGlobal: lot.idGlobal,
                    kizOsuDto: lot.kizOsuDto !== undefined && lot.kizOsuDto !== null && lot.kizOsuDto.barcode !== null ? {...lot.kizOsuDto, idDocumentItem: entity.idGlobal } : undefined,
                    isOsu: (lot.kizOsuDto !== null && lot.kizOsuDto?.barcode !== null) || lot.isPieceAccountingKizOsu, // TODO: разделить признаки ОСУ и ПЭУ
                    gtinOsu: lot.gtinOsu,
                    isPieceAccountingKizOsu: lot.isPieceAccountingKizOsu, // ПЭУ,
                    numerator: lot.numerator,
                    denominator: lot.denominator,
                    documentalQuantity: lot.quantityRem
                };

                setDisabled(true);
                setLot({ idGlobal: lot.idGlobal, displayName: lot.displayName });
                setGoods({ ...lot.goods });
                setScalingRatio({ ...lot.scalingRatio });
                setProducerPrice(lot.producerPrice);
                setEntity(entityObj);

                // Если поиск по КИЗ/Коробу и неделенный товар
                // Сразу вернуть
                const isDivided: boolean = (lot.numerator < lot.denominator)
                if (props.data.searchQuery && (lot.isKiz || lot.isKizBox)) {
                    tabContext.closeCurrent();

                    // Контроль количества для целой партии
                    if (!isDivided) {
                        entityObj.quantity = kizQuantity.current++;
                        if (entityObj.quantity === 0) 
                            entityObj.quantity = 1;
                    }

                    // Добавляемая строка
                    const item = {
                        entityObj,
                        lot
                    }

                    const callback = (dtoItems: any) => {
                        props.onSubmit?.(dtoItems?.editItem as IInventoryVedItemEditDTO, dtoItems?.viewItem as IInventoryVedItemViewDTO);
                    }

                    makeInventoryVedDtoItems(item, callback);

                } else {

                    // Штатно запросить поставщика
                    contractorDP.getById(lot.idSupplierGlobal, (d) => setSupplier({ idGlobal: d.idGlobal, displayName: d.name }));
                    taxTypeDP.getByRate(lot.supplierCostInfo?.vat ?? 0, (value) => {
                        setSupplierCostInfo(
                            { 
                                ...lot.supplierCostInfo,
                                sum: roundMoneyFormat(lot.supplierCostInfo.price * entityObj.quantity),
                                vatSum: roundMoneyFormat(lot.supplierCostInfo.vatPrice * entityObj.quantity),
                                sumIncVat: roundMoneyFormat(lot.supplierCostInfo.priceIncVat * entityObj.quantity),
                                vat: value.taxRate 
                            });
                        setSupplierTaxType({ idGlobal: value.idGlobal, displayName: value.displayName });
                    });
                    taxTypeDP.getByRate(lot.retailCostInfo?.vat ?? 0, (value) => {
                        setRetailCostInfo(
                            { 
                                ...lot.retailCostInfo,
                                sum: roundMoneyFormat(lot.retailCostInfo.price * entityObj.quantity),
                                vatSum: roundMoneyFormat(lot.retailCostInfo.vatPrice * entityObj.quantity),
                                sumIncVat: roundMoneyFormat(lot.retailCostInfo.priceIncVat * entityObj.quantity),
                                vat: value.taxRate 
                            });
                        setRetailTaxType({ idGlobal: value.idGlobal, displayName: value.displayName });
                    });
                }
                break;

            case "goods":
                const goods = props?.data?.goods;
                const targetQuantity: number = props.variant === "create" ? 1 : entity.quantity;
                if (goods?.idGlobal) {
                    goodsDP.getByIdAndScalingRatio(goods.idGlobal, uuidNull, (goodsResult) => {
                        if (goodsResult?.gnvls && goodsResult?.gnvls.registerPrice) {
                            setEntity({ ...entity, quantity: targetQuantity, hasLot: false, registerPrice: goodsResult.gnvls.registerPrice});
                        }

                        if (goodsResult?.idGlobal && goodsResult?.scalingRatio.idGlobal) {
                            scalingRatioDP.overrideGetById(goods?.idGlobal, goodsResult?.scalingRatio.idGlobal, (e) => {
                                setScalingRatio({ displayName: e.displayName, idGlobal: e.idGlobal });
                            });
                        }
                    });
                }
                else {
                    setEntity({ ...entity, quantity: targetQuantity, hasLot: false });
                }
                setDisabled(false);
                setGoods({ ...props.data.goods });

                // Запросить НДС
                goodsDP.getById(goods.idGlobal, (entity: IGoodsDTO) => {
                    setIsGnvls(entity.gnvls.important ?? false);
                    if (entity.taxType?.idGlobal?.length > 0) {
                        taxTypeDP.getById(entity.taxType.idGlobal, (taxType: ITaxTypeDTO) => {

                            setSupplierCostInfo((prev) => (
                                {
                                    ...prev,
                                    sum: roundMoneyFormat(prev.price * targetQuantity),
                                    vatSum: roundMoneyFormat(prev.vatPrice * targetQuantity),
                                    sumIncVat: roundMoneyFormat(prev.priceIncVat * targetQuantity),
                                    vat: taxType.taxRate
                                }));
                            setSupplierTaxType({ idGlobal: taxType.idGlobal, displayName: taxType.displayName });

                            setRetailCostInfo((prev) => (
                                {
                                    ...prev,
                                    sum: roundMoneyFormat(prev.price * targetQuantity),
                                    vatSum: roundMoneyFormat(prev.vatPrice * targetQuantity),
                                    sumIncVat: roundMoneyFormat(prev.priceIncVat * targetQuantity),
                                    vat: taxType.taxRate
                                }));
                            setRetailTaxType({ idGlobal: taxType.idGlobal, displayName: taxType.displayName });
                        })
                    }
                });
                break;

            case "entity":
                const editEntity = props.data.entity;
                
                setDisabled(editEntity.hasLot);
                setProducerPrice(editEntity.producerPrice);
                contractorDP.getById(editEntity.idSupplierGlobal, (contractorDto) => {
                    setSupplier({ idGlobal: contractorDto.idGlobal, displayName: contractorDto.name })}
                );

                setEntity({ ...editEntity })

                goodsDP.getById(editEntity.idGoodsGlobal, (goodsDto) => {
                    setGoods({ idGlobal: editEntity.idGoodsGlobal, displayName: goodsDto.goodsName.name })
                    setIsGnvls(goodsDto.gnvls.important ?? false)
                });

                scalingRatioDP.overrideGetById(editEntity.idGoodsGlobal, editEntity.idScalingRatioGlobal, (scalingRatioDto) => {
                    setScalingRatio({ idGlobal: scalingRatioDto.idGlobal, displayName: scalingRatioDto.displayName })
                });

                taxTypeDP.getByRate(editEntity.supplierCostInfo?.vat ?? 0, (value) => {
                    setSupplierCostInfo({ ...editEntity.supplierCostInfo, vat: value.taxRate });
                    setSupplierTaxType({ idGlobal: value.idGlobal, displayName: value.displayName });
                });

                taxTypeDP.getByRate(editEntity.retailCostInfo?.vat ?? 0, (value) => {
                    setRetailCostInfo({ ...editEntity.retailCostInfo, vat: value.taxRate });
                    setRetailTaxType({ idGlobal: value.idGlobal, displayName: value.displayName });
                });

                break;
        }
    }, [props.data]);

    const makeInventoryVedDtoItems = (data: any = null, callback: (dtoItems: any) => void = () => {}) => {

        let entityDto : IInventoryVedItemEditDTO = data ? data.entityObj : entity;
        let goodsDto : IEntitySimpleDTO = data ? { ...data.lot.goods } : goods;
        let scalingRatioDto = data ? { ...data.lot.scalingRatio } : scalingRatio;
        let supplierDto : IEntitySimpleDTO | null = supplier;

        let supplierCostInfoDto = {
            ...supplierCostInfo,
            sum: roundMoneyFormat(supplierCostInfo.price * entityDto.quantity),
            vatSum: roundMoneyFormat(supplierCostInfo.vatPrice * entityDto.quantity),
            sumIncVat: roundMoneyFormat(supplierCostInfo.priceIncVat * entityDto.quantity)
        };
        let retailCostInfoDto = {
            ...retailCostInfo,
            sum: roundMoneyFormat(retailCostInfo.price * entityDto.quantity),
            vatSum: roundMoneyFormat(retailCostInfo.vatPrice * entityDto.quantity),
            sumIncVat: roundMoneyFormat(retailCostInfo.priceIncVat * entityDto.quantity)
        };
        let lotDto : IEntitySimpleDTO = data ? data.lot : lot;

        const act = () => {
            if (!goodsDto || !scalingRatioDto || !supplierDto) {
                return;
            }
    
            const editItem: IInventoryVedItemEditDTO = {
                ...entityDto,
                idGoodsGlobal: goodsDto.idGlobal,
                idScalingRatioGlobal: scalingRatioDto.idGlobal,
                idSupplierGlobal: supplierDto.idGlobal,
                supplierCostInfo: supplierCostInfoDto,
                retailCostInfo: retailCostInfoDto,
                kizs: entityDto.kizs ?? [],
                kizBoxes: entityDto.kizBoxes ?? [],
                producerPrice: producerPrice
            };
    
            const viewItem: IInventoryVedItemViewDTO = {
                internalBarcode: entityDto.internalBarcode ?? "",
                displayName: goodsDto.displayName,
                idDocumentGlobal: "",
                retailVat: retailCostInfoDto.vat,
                retailPrice: retailCostInfoDto.price,
                retailVatPrice: retailCostInfoDto.vatPrice,
                retailPriceIncVat: retailCostInfoDto.priceIncVat,
                retailSum: retailCostInfoDto.sum,
                retailVatSum: retailCostInfoDto.vatSum,
                retailSumIncVat: retailCostInfoDto.sumIncVat,
                retailAdprice: retailCostInfoDto.adprice,
                supplierVat: supplierCostInfoDto.vat,
                supplierPrice: supplierCostInfoDto.price,
                supplierVatPrice: supplierCostInfoDto.vatPrice,
                supplierPriceIncVat: supplierCostInfoDto.priceIncVat,
                supplierSum: supplierCostInfoDto.sum,
                supplierVatSum: supplierCostInfoDto.vatSum,
                supplierSumIncVat: supplierCostInfoDto.sumIncVat,
                supplierAdprice: supplierCostInfoDto.adprice,
                lotName: lotDto?.displayName ?? (goodsDto?.displayName ?? ""),
                goodsName: goodsDto.displayName,
                scalingRatioName: scalingRatioDto.displayName,
                supplierName: supplierDto.displayName,
                seriesName: "",
                regCertName: "",
                gosContractGoodsName: "",
                idGlobal: entityDto.idGlobal,
                quantity: entityDto.quantity,
                quantityRem: entityDto.quantityRem,
                hasLot: entityDto.hasLot,
                supplierDocNumber: entityDto.supplierDocNumber ?? null,
                supplierBillDocNumber: entityDto.supplierBillDocNumber ?? null,
                supplierDocDate: entityDto.supplierDocDate,
                supplierBillDocDate: entityDto.supplierBillDocDate,
                invoiceNum: entityDto.invoiceNum,
                invoiceDate: entityDto.invoiceDate,
                gtdNumber: entityDto.gtdNumber ?? "",
                registerPrice: entityDto.registerPrice ?? 0,
                producerPrice: producerPrice,
                isKiz: entityDto.isKiz,
                isKizBox: entityDto.isKizBox,
                kizCount: entityDto.kizs?.length ?? 0,
                kizBoxCount: entityDto.kizBoxes?.length ?? 0,
                kizScannedCount: entityDto.isOsu === true && entityDto.gtinOsu?.length as number > 0 ? `1 из 1` :
                    entityDto.isKiz || entityDto.isKizBox ?
                        ((entityDto.kizs?.length ?? 0) + (entityDto.kizBoxes?.length ?? 0)) + ` из ${entityDto.quantityRem}` : '-',
                countKizScan: entityDto.isOsu === true && entityDto.gtinOsu?.length as number > 0 ?
                    1 :
                    (entityDto.kizs?.length ?? 0) + (entityDto.kizBoxes?.length ?? 0),
                isOsu: entityDto?.isOsu,
                numerator: entityDto.numerator as number,
                denominator: entityDto.denominator as number,
                documentalQuantity: entityDto.quantityRem as number
            };
    
            return { editItem, viewItem };
        }

        if (data) {
            contractorDP.getById(data.lot.idSupplierGlobal, (d) => {
                supplierDto = { idGlobal: d.idGlobal, displayName: d.name };

                taxTypeDP.getByRate(data.lot.supplierCostInfo?.vat ?? 0, (value) => {
                    supplierCostInfoDto = { 
                        ...data.lot.supplierCostInfo,
                        sum: roundMoneyFormat(data.lot.supplierCostInfo.price * entityDto.quantity),
                        vatSum: roundMoneyFormat(data.lot.supplierCostInfo.vatPrice * entityDto.quantity),
                        sumIncVat: roundMoneyFormat(data.lot.supplierCostInfo.priceIncVat * entityDto.quantity),
                        vat: value.taxRate 
                    };

                    taxTypeDP.getByRate(data.lot.retailCostInfo?.vat ?? 0, (value) => {
                        retailCostInfoDto = { 
                            ...data.lot.retailCostInfo,
                            sum: roundMoneyFormat(data.lot.retailCostInfo.price * entityDto.quantity),
                            vatSum: roundMoneyFormat(data.lot.retailCostInfo.vatPrice * entityDto.quantity),
                            sumIncVat: roundMoneyFormat(data.lot.retailCostInfo.priceIncVat * entityDto.quantity),
                            vat: value.taxRate 
                        };

                        const items = act();
                        if (callback) {
                            callback(items);
                        }
                    });
                });
            });
        } else {
            return act();
        }
    }

    const okButton: IButton = {
        onClick() {
            const valid = isValid();
            if (valid) {
                const items = makeInventoryVedDtoItems();
                props.onSubmit?.(items?.editItem as IInventoryVedItemEditDTO, items?.viewItem as IInventoryVedItemViewDTO);
                tabContext.closeCurrent();
            }
        },
    };

    const cancelButton: IButton = {
        onClick() {
            tabContext.closeCurrent();
        },
    };

    useEffect(() => {
        if (goods) {
            goodsDP.getById(goods.idGlobal, (value) => {
                setSupplierTaxType({ ...value.taxType });
                setRetailTaxType({ ...value.taxType });
            });
        }
    }, [goods]);

    useEffect(() => {
        if (supplierTaxType) {
            taxTypeDP.getById(supplierTaxType.idGlobal, (value) => setSupplierCostInfo((prev) => ({ ...prev, vat: value.taxRate })));
        } else {
            setSupplierCostInfo((prev) => ({ ...prev, vat: 0 }));
        }
    }, [supplierTaxType]);

    useEffect(() => {
        if (retailTaxType) {
            taxTypeDP.getById(retailTaxType.idGlobal, (value) => setRetailCostInfo((prev) => ({ ...prev, vat: value.taxRate })));
        } else {
            setRetailCostInfo((prev) => ({ ...prev, vat: 0 }));
        }
    }, [retailTaxType]);

    const onQuantityChange = (quantity: number) => {
        setSupplierCostInfo({
            ...supplierCostInfo,
            sum: roundMoneyFormat(supplierCostInfo.price * quantity),
            vatSum: roundMoneyFormat(supplierCostInfo.vatPrice * quantity),
            sumIncVat: roundMoneyFormat(supplierCostInfo.priceIncVat * quantity),
        });
        setRetailCostInfo({
            ...retailCostInfo,
            sum: roundMoneyFormat(retailCostInfo.price * quantity),
            vatSum: roundMoneyFormat(retailCostInfo.vatPrice * quantity),
            sumIncVat: roundMoneyFormat(retailCostInfo.priceIncVat * quantity),
        });
        setEntity({ ...entity, quantity: quantity });
    };

    const onProducerPriceChange = (producerPrice: number) => {
        setSupplierCostInfo({
            ...supplierCostInfo,
            adprice: producerPrice ? roundMoneyFormat((100 * supplierCostInfo.priceIncVat / producerPrice) - 100) : 0
        });
    }

    const onSupplierPriceIncVatChange = (supplierPriceIncVat: number) => {

        if ((supplierTaxType?.idGlobal as string).length > 0) {
            taxTypeDP.getById(supplierTaxType?.idGlobal as string, (tax: ITaxTypeDTO) => {

                const price: number = roundMoneyFormat((supplierPriceIncVat * 100) / (100 + tax.taxRate))
                setSupplierCostInfo({
                    ...supplierCostInfo,
                    priceIncVat: roundMoneyFormat(supplierPriceIncVat),
                    sumIncVat: roundMoneyFormat(supplierPriceIncVat * entity.quantity),
                    price: price,
                    sum: price * entity.quantity,
                    vatPrice: roundMoneyFormat(supplierPriceIncVat - price),
                    vatSum: roundMoneyFormat((supplierPriceIncVat - price) * entity.quantity),
                    adprice: producerPrice ? roundMoneyFormat(((100 * supplierPriceIncVat) / producerPrice) - 100) : 0
                });
                setRetailCostInfo({
                    ...retailCostInfo,
                    adprice: roundMoneyFormat(((100 * retailCostInfo.priceIncVat) / supplierPriceIncVat) - 100)
                })
            });
        }
    }

    const onRetailPriceIncVatChange = (retailPriceIncVat: number) => {
        if ((supplierTaxType?.idGlobal as string).length > 0) {
            taxTypeDP.getById(supplierTaxType?.idGlobal as string, (tax: ITaxTypeDTO) => {

                const price: number = roundMoneyFormat((retailPriceIncVat * 100) / (100 + tax.taxRate))
                setRetailCostInfo({
                    ...retailCostInfo,
                    priceIncVat: roundMoneyFormat(retailPriceIncVat),
                    sumIncVat: roundMoneyFormat(retailPriceIncVat * entity.quantity),
                    price: price,
                    sum: price * entity.quantity,
                    vatPrice: roundMoneyFormat(retailPriceIncVat - price),
                    vatSum: roundMoneyFormat((retailPriceIncVat - price) * entity.quantity),
                    adprice: roundMoneyFormat(((100 * retailPriceIncVat) / supplierCostInfo.priceIncVat) - 100)
                });
            });
        }
    }

    return (
        
        <>{ !(props.data.searchQuery && props.data.type === "lot" && (props.data.lot.isKiz || props.data.lot.isKizBox) && !(props.data.lot.numerator < props.data.lot.denominator)) && 
            <BaseDocumentCreator ok={okButton} cancel={cancelButton}>
                <GridWrapper cols={4}>
                    <ContractorSelectorInput
                        label="Поставщик"
                        selectedEntity={supplier}
                        required
                        onSelect={(value) => setSupplier({ ...value })}
                        onClear={() => setSupplier(null)}
                        disabled={disabled}
                        error={errors.supplier}
                    />
                    <GoodsSelectorInput
                        label="Номенклатура"
                        selectedEntity={goods}
                        required 
                        onSelect={(value) => setGoods({ ...value })}
                        onClear={() => setGoods(null)}
                        disabled={disabled}
                        error={errors.goods}
                    />
                    <ScalingRatioSelectorInput
                        label="Единица измерения"
                        selectedEntity={scalingRatio}
                        required
                        masterIdGlobal={goods?.idGlobal}
                        onSelect={(value) => setScalingRatio({ ...value })}
                        onClear={() => setScalingRatio(null)}
                        disabled={disabled}
                        error={errors.scalingRatio}
                    />
                    {(props.data.type === "goods" || (props.data.type === "entity" && !props.data.byLot)) &&
                        <div className={classNames(styles.isGnvls, !isGnvls && styles.isGnvls_Disabled)}> ЖВ </div>
                    }
                </GridWrapper>
                <GridWrapper cols={8}>
                {
                    (props.data.type === "goods" || (props.data.type === "entity" && !props.data.byLot)) && 
                        <>
                            <DecimalInputV2
                                labelVariant={isGnvls ? "required" : "normal"}
                                required={isGnvls}
                                label={t("documents.invoice.manufacturerPrice")}//"Цена производителя"
                                inputId={"manufacturerPrice"}
                                error={errors.producerPrice}
                                onFocus={() => setErrors({ ...errors, producerPrice: undefined })}
                                value={producerPrice}
                                onChange={(value: number) => {
                                    setProducerPrice(value);
                                    onProducerPriceChange(value);
                                }}
                                onEndChange={(value: number) => {
                                    setProducerPrice(value);
                                    onProducerPriceChange(value)
                                }}
                            />
                            <GridSelectorInput
                                required={isGnvls}
                                numereticInput
                                label={t("documents.invoice.manufacturerMarginalPrice")}
                                id="manufacturerMarginalPrice"
                                data={{...goods, validateReestr}}
                                selectedEntity={entity.registerPrice}
                                selectorModalJsx={RegisterPriceSelectorModal}
                                onSelect={(e) => {
                                    setEntity({ ...entity, registerPrice: e});
                                    if (producerPrice > e ) {
                                        setErrors({...errors, producerPrice: errorsT('exceededProducerPrice')});
                                    }
                                }}
                                onClear={() => setEntity({ ...entity, registerPrice: 0 })}
                                disabled={!isGnvls}
                                error={errors.registerPrice}
                                onFocus={() => setErrors({ ...errors, registerPrice: undefined })}
                            />
                        </>
                }
                    <NumberInput label="Кол-во" value={entity.quantity} onChange={onQuantityChange} />
                    <NumberInput label="Док. остаток" value={entity.quantityRem} disabled />
                    <TextInput label="GTD" value={entity.gtdNumber ?? ""} onChange={(value) => setEntity({ ...entity, gtdNumber: value })} disabled={disabled} />
                </GridWrapper>
                <Accordion opened={true} caption="Расчет&nbsp;отпускной&nbsp;цены" id="CalculationOfTheSellingPriceInventoryVedItem">
                    <FlexRow wrap>
                        <TaxTypeSelectorInput
                            label="Ставка НДС, пост."
                            selectedEntity={supplierTaxType}
                            onSelect={(value) => setSupplierTaxType({ ...value })}
                            onClear={() => setSupplierTaxType(null)}
                            disabled={disabled}
                        />
                        <MoneyFormatComponent label="Наценка, %, пост." value={supplierCostInfo.adprice} disabled={disabled} />
                        <MoneyFormatComponent label="НДС за единицу, пост." value={supplierCostInfo.vatPrice} disabled={disabled} />
                        <MoneyFormatComponent label="Цена б/НДС, пост." value={supplierCostInfo.price} disabled={disabled} />
                        <MoneyFormatComponent label="Сумма пост. б/НДС" value={supplierCostInfo.sum} disabled={disabled} />
                        <MoneyFormatComponent label="Сумма НДС, пост." value={supplierCostInfo.vatSum} disabled={disabled} />
                        {(props.data.type === "goods" || (props.data.type === "entity" && !props.data.byLot)) ?
                            <DecimalInputV2
                                required
                                label={baseT("supplierPriceWithVat")}
                                inputId={"supplierPriceWithVat"}
                                value={supplierCostInfo.priceIncVat}
                                error={errors.supplierPriceWithVat}
                                onChange={(value: number) => {
                                    setSupplierCostInfo({
                                        ...supplierCostInfo,
                                        priceIncVat: value
                                    });
                                    onSupplierPriceIncVatChange(value);
                                }}
                                onEndChange={(value: number) => {
                                    setSupplierCostInfo({
                                        ...supplierCostInfo,
                                        priceIncVat: value
                                    });
                                    onSupplierPriceIncVatChange(value);
                                }}
                            >
                            </DecimalInputV2> :
                            <MoneyFormatComponent
                                label="Цена с НДС, пост."
                                value={supplierCostInfo.priceIncVat}
                                disabled={disabled}
                            />
                        }
                        <MoneyFormatComponent label="Сумма с НДС, пост." value={supplierCostInfo.sumIncVat} disabled={disabled} />
                    </FlexRow>
                    <FlexRow wrap>
                        <TaxTypeSelectorInput
                            label="Ставка НДС, розн."
                            selectedEntity={retailTaxType}
                            onSelect={(value) => setRetailTaxType({ ...value })}
                            onClear={() => setRetailTaxType(null)}
                            disabled={disabled}
                        />
                        <MoneyFormatComponent label="Наценка, %, розн." value={retailCostInfo.adprice} disabled={disabled} />
                        <MoneyFormatComponent label="НДС за единицу, розн." value={retailCostInfo.vatPrice} disabled={disabled} />
                        <MoneyFormatComponent label="Цена б/НДС, розн." value={retailCostInfo.price} disabled={disabled} />
                        <MoneyFormatComponent label="Сумма розн. б/НДС" value={retailCostInfo.sum} disabled={disabled} />
                        <MoneyFormatComponent label="Сумма НДС, розн." value={retailCostInfo.vatSum} disabled={disabled} />
                        {(props.data.type === "goods" || (props.data.type === "entity" && !props.data.byLot)) ?
                            <DecimalInputV2
                                variant="green"
                                labelVariant="green"
                                label={baseT("sellingPrice")}
                                inputId={"sellingPrice"}
                                value={retailCostInfo.priceIncVat}
                                error={errors.retailPriceWithVat}
                                onChange={(value: number) => {
                                    setRetailCostInfo({
                                        ...retailCostInfo,
                                        priceIncVat: value
                                    });
                                    onRetailPriceIncVatChange(value);
                                }}
                                onEndChange={(value: number) => {
                                    setRetailCostInfo({
                                        ...retailCostInfo,
                                        priceIncVat: value
                                    });
                                    onRetailPriceIncVatChange(value);
                                }}
                            >
                            </DecimalInputV2> : <MoneyFormatComponent label="Цена с/НДС, розн." value={retailCostInfo.priceIncVat} disabled={disabled} labelVariant="green" variant="green" />}
                        <MoneyFormatComponent label="Сумма с/НДС, розн." value={retailCostInfo.sumIncVat} disabled={disabled} labelVariant="green" variant="green" />
                    </FlexRow>
                    <FlexRow>
                        <Link 
                            className={styles.sertificate} 
                            onClick={() => setIsOpenSeriesModal(true)}
                        >
                            Серии и сертификаты
                        </Link>
                        <Link className={styles.margin20}>Региональные сертификаты</Link>
                        <Link>История поставок</Link>
                    </FlexRow>
                </Accordion>

                {isOpenSeriesModal && (
                    <SeriesModalWindow 
                        cancel={() => setIsOpenSeriesModal(false)} 
                        goods={goods as IEntitySimpleDTO} 
                        setItemSeries={(value: ISerialDTO) => setItemSeries(value)} 
                        itemSeries={itemSeries} 
                    />
                )}
            </BaseDocumentCreator>
            }
        </>
    );
};

export default InventoryVedItemForm;
